import intlTelInput from 'intl-tel-input';

document.addEventListener('alpine:init', () => {

    Alpine.data('phoneInput', (id, containerClass, modelPath, userCountry, onlyCountries = []) => ({
        /**
         * @var string identifier attribute of the input
         */
        id: id,

        /**
         * @var String container class of phone number plugin
         */
        containerClass: containerClass,

        /**
         * @var String component container class
         */
        componentClass: 'phone-input',

        /**
         * @var String Livewire model path
         */
        modelPath: modelPath,


        /**
         * User country code related to current user.
         */
        userCountry: userCountry,

        /**
         * @var Iti phone number plugin instance.
         */
        iti: null,

        /**
         * @var Array allowed countries for country dropdown.
         * Empty array means all countries allowed.
         */
        onlyCountries: onlyCountries,

        /**
         * Initialize the input.
         *
         * @return void
         */
        construct() {
             this.initInput(this.containerClass);
        },

        /**
         * Initialize the input plugin.
         *
         * @return HTMLInputElement
         */
        initInput(containerClass) {
            const input = document.querySelector(`#${this.id}`);
            this.iti = intlTelInput(input, {
                initialCountry: userCountry,
                strictMode: true,
                loadUtils: () => import("intl-tel-input/utils"),
                containerClass: containerClass,
                useFullscreenPopup: false,
                onlyCountries: this.onlyCountries,
            });
            this.setListenerIfModelNotEmpty(this.id, modelPath, 'blur');
            this.iti.setNumber(this.$wire.get(modelPath));
            this.initSeparator();
            this.initSelectedCountry();
            this.initEvents(input);
        },

        /**
         * Initialize adding HTML separator (<hr> element).
         */
        initSeparator() {
            this.iti.promise.then(() => {
                if (this.iti.searchInput) {
                    const hr = document.createElement("hr");
                    this.iti.searchInput.after(hr);
                }
            });
        },

        /**
         * Initialize adding selected country.
         */
        initSelectedCountry() {
            if (this.iti.selectedCountryInner) {
                this.iti.countries.forEach((country) => {
                    if (country.nodeById[this.iti.id]) {
                        country.nodeById[this.iti.id].classList.remove('selected');
                    }
                })

                this.iti.countryList
                    .querySelectorAll('.selected')
                    .forEach(el => el.classList.remove('selected'));

                this.iti.countryList
                    .querySelector('[data-country-code="' + this.iti.selectedCountryData.iso2 + '"]')
                    .classList
                    .add('selected');
            }
        },

        /**
         * Initialize Input Events.
         *
         * @param {HTMLInputElement} input
         */
        initEvents(input) {
            const itiClassList = (event) => event.target.closest('.iti').classList;

            input.addEventListener('countrychange', (e) => {
                this.initSelectedCountry();
                this.$refs.phone.value = this.iti.getNumber(intlTelInput.utils.numberFormat.E164);
            });
            input.addEventListener('open:countrydropdown', (e) => {
                itiClassList(e).add('opened');
            });
            input.addEventListener('close:countrydropdown', (e) => {
                itiClassList(e).remove('opened');
            })
        },

        /**
         * Set the event listener for Livewire model if model is specified.
         *
         * @param {string} inputId input element ID.
         * @param {string|undefined} model path to the Livewire model.
         * @param {string|undefined} listenerType (change, blur, ...)
         */
        setListenerIfModelNotEmpty(inputId, model, listenerType) {
            if (model) {
                this.setLivewireModelListener(inputId, model, listenerType);
            }
        },

        /**
         * Set the event listener to sync the input value for Livewire model.
         *
         * @param {string} inputId input element ID.
         * @param {string} modelPath path to the Livewire model.
         * @param {string|undefined} listenerType (change, blur, ...)
         */
        setLivewireModelListener(inputId, modelPath, listenerType = 'change') {
            const input = document.getElementById(inputId);
            input.addEventListener(listenerType, () => {
                this.$wire.set(modelPath, this.iti.getNumber(intlTelInput.utils.numberFormat.E164))
            });
        },
    }));
});